module.exports = __webpack_public_path__ + "media/images/svg-sprite-items/payment/ideal-62b4f409556c9819f9ef99b23479700d.svg";